const CANCEL_ORDER_MODAL = (() => {
  const modalDialogCancelOrder = document.getElementById('modal-dialog-cancel-order');
  const cautionScreen = document.querySelector('.cancel-order-modal__screen--caution');
  const successScreen = document.querySelector('.cancel-order-modal__screen--success');
  const errorScreen = document.querySelector('.cancel-order-modal__screen--error');
  const confirmButton = document.querySelector('.cancel-order-modal__confirm-button');
  const confirmButtonContents = document.querySelector(
    '.cancel-order-modal__confirm-button action-button-contents',
  );

  document.querySelectorAll('.cancel-order-modal__dismiss-button').forEach((button) => {
    button.addEventListener('click', () => {
      closeModal();
    });
  });

  confirmButton.addEventListener('click', () => {
    confirmButton.disabled = true;
    confirmButtonContents.showLoadingState();
    cancelOrder();
  });

  const openModal = () => {
    cautionScreen.classList.remove('hidden');
    [successScreen, errorScreen].forEach(screen => screen.classList.add('hidden'));
    confirmButton.disabled = false;
    confirmButtonContents.hideLoadingState();
    modalDialogCancelOrder.setAttribute('open', 'open');
    document.body.classList.add('overflow-hidden');
  };

  const closeModal = () => {
    modalDialogCancelOrder.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  };

  /**
   * Cancel an order
   */
  const cancelOrder = async () => {
    const params = new URLSearchParams(window.location.search);
    const orderUuid = params.get('orderUuid');
    const query = `
      mutation orderCancel(
        $orderUuid: String!
      ) {
        orderCancel(orderUuid: $orderUuid) {
          state
        }
      }
    `;
    const param = 'query-orderCancel';
    try {
      const response = await fetchWithAppName(`${global.url}${param}`, {
        body: JSON.stringify({ query, variables: { orderUuid } }),
      });

      const jsonData = await response.json();
      if (jsonData.errors) {
        throw new Error(
          `Failed to cancel order. API returned GraphQL errors. [orderUuid=${orderUuid}, errors=${
            JSON.stringify(jsonData.errors)
          }]`,
        );
      }

      if (!jsonData.data?.orderCancel?.state === 'CANCELED') {
        throw new Error(
          `Failed to cancel order. API returned an unexpected order state. [orderUuid=${
            orderUuid
          }, state=${jsonData.data?.orderCancel?.state}]`,
        );
      }

      successScreen.classList.remove('hidden');
    } catch (e) {
      console.error(e);
      errorScreen.classList.remove('hidden');
    } finally {
      cautionScreen.classList.add('hidden');
      // Always refresh order details after every attempt to cancel an order. In the success case,
      // this lets us display the updated order status. It's handy in the error case too since one
      // likely cause of errors is that an order that was still in the pick delay window when the
      // customer loaded the order-status page left the pick delay window by the time the customer
      // tried to cancel the order. Refreshing lets us switch to the disabled version of the Cancel
      // Order CTA in that case.
      await getOrderDetails();
    }
  };

  return {
    openModal,
  };
})();
